module.exports = '<svg width="36" height="32" viewBox="0 0 36 32"><path d="M28.389 9.712V2.62c0-.559-.442-1.013-1.001-1.013h-2.03a1.02 1.02 0 0 0-1.021 1.013v3.039L18.97.296a1.011 1.011 0 0 0-1.43 0L.228 17.099c-.395.395-.263.717.296.717h3.55v13.17a.999.999 0 0 0 .997 1.013h8.115c.559 0 1.019-.454 1.019-1.013v-8.105c0-.559.45-1.013 1.009-1.013h6.087a1.01 1.01 0 0 1 1.009 1.013v8.105c0 .559.46 1.013 1.019 1.013h8.115a.999.999 0 0 0 .997-1.013v-13.17h3.503c.559 0 .687-.32.292-.717L28.39 9.711z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/house-3.js
// module id = 1176
// module chunks = 14